module.exports = __webpack_public_path__ + "static/media/26_A.f09e8c46.png";